import React, { ChangeEvent, Component } from "react";
import IErrorDTO from "../../../models/DTO/IErrorDTO";
import IGetCatalogsDTO from "../../../models/DTO/IGetCatalogsDTO";
import IOnGetCatalogsDTO from "../../../models/DTO/IOnGetCatalogsDTO";
import IOnProcessTakeOffOrderDTO from "../../../models/DTO/IOnProcessTakeOffOrderDTO";
import IProcessTakeOffOrderDTO from "../../../models/DTO/IProcessTakeOffOrderDTO";
import EndpointsEnum from "../../../models/EndpointsEnum";
import ICatalog from "../../../models/ICatalog";
import INotification from "../../../models/INotification";
import ISupplierModel from "../../../models/ISupplierModel";
import ITake_Off from "../../../models/ITake_Off";
import IUserUI from "../../../models/IUserUI";
import NotificationLevelEnum from "../../../models/NotificationLevelEnum";
import NotificationPositionEnum from "../../../models/NotificationPositionEnum";
import OwButton from "../../shared/OwButton/OwButton";
import OwInputWrapper from "../../shared/OwInputWrapper/OwInputWrapper";
import OwLabel from "../../shared/OwLabel/OwLabel";
import OwSelectOption from "../../shared/OwSelectOption/OwSelectOption";
import OwTitle from "../../shared/OwTitle/OwTitle";
import { Socket } from "socket.io-client";

type Props = {
    cancelFn: (refreshData?: boolean) => void;
    userModel: IUserUI;
    supplierModel: ISupplierModel;
    setActivityIndicator: (activityIndicator: boolean) => void;
    socket: Socket;
    notifyFn: (data: IErrorDTO | null, _notification?: INotification, isFormatted?: boolean) => void;
    takeOff: ITake_Off;
};

type State = {
    createActive: boolean;
    description: string;
    catalogs: ICatalog[];
    catalog_id?: number;
};

class TakeOffDetailSidebar extends Component<Props, State> {
    constructor(props: any) {
        super(props);

        this.state = {
            createActive: false,
            description: "",
            catalogs: [],
        };
    }

    componentDidMount(): void {
        this.props.socket.on(EndpointsEnum.TakeOffOnProcessTakeOffOrder, this.onProcessTakeOffOrder);
        this.props.socket.on(EndpointsEnum.CatalogsOnGetCatalogs, this.onGetCatalogs);

        this.getCatalogs();
    }

    componentWillUnmount(): void {
        this.props.socket.removeListener(EndpointsEnum.TakeOffOnProcessTakeOffOrder, this.onProcessTakeOffOrder);
        this.props.socket.removeListener(EndpointsEnum.CatalogsOnGetCatalogs, this.onGetCatalogs);
    }

    cancel = (refreshData?: boolean) => {
        this.props.cancelFn(refreshData);
    };

    create = () => {
        const payload: IProcessTakeOffOrderDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            takeOffGuid: this.props.takeOff.guid,
            takeOffOrder: {
                description: this.state.description,
                catalog_id: this.state.catalog_id,
            },
        };

        this.props.socket.emit(EndpointsEnum.TakeOffProcessTakeOffOrder, payload);
    };

    onProcessTakeOffOrder = (data: IOnProcessTakeOffOrderDTO) => {
        const notification: INotification = {
            message: "successfully_processed_take_off",
            level: NotificationLevelEnum.success,
            position: NotificationPositionEnum.bc,
        };

        this.props.notifyFn(null, notification);

        this.props.cancelFn();
    };

    getCatalogs = () => {
        const payload: IGetCatalogsDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            vendorGuid: this.props.takeOff.Vendor!.guid,
            onlyActive: true,
            callMeta: {
                view: "TakeOffDetailSidebar",
                fn: "getCatalogs",
            },
        };

        this.props.socket.emit(EndpointsEnum.CatalogsGetCatalogs, payload);
    };

    onGetCatalogs = (data: IOnGetCatalogsDTO) => {
        this.setState({
            catalogs: data.catalogs,
        });
    };

    handleChange = (e: ChangeEvent<any>) => {
        const value = e.target.type === "checked" ? e.target.checked : e.target.value;
        const name = e.target.name;

        const state: any = {
            [name]: value,
        };

        this.setState(state);
    };

    render() {
        return (
            <div className={"TakeOffDetailSidebar p-2"}>
                <div className={"col-12"}>
                    <div className="text-end">
                        <button
                            className="btn btn-danger btn-sm"
                            onClick={() => {
                                this.cancel();
                            }}>
                            <i className="far fa-times" />
                        </button>
                    </div>
                    <OwTitle className={"mb-2"} title={"take_off"} />
                    <hr />
                </div>

                <div className={""}>
                    <OwLabel title={"description"} showIsReqAsterik={true} />
                    <OwInputWrapper name={"description"} fn={this.handleChange} value={this.state.description} />
                </div>

                <div className={"mt-3"}>
                    <OwLabel title={"catalog"} showIsReqAsterik={true} />
                    <OwSelectOption
                        fn={this.handleChange}
                        options={this.state.catalogs}
                        valueProp={"id"}
                        titleProp={"name"}
                        showBlankFirst={true}
                        selectedOption={this.state}
                        selectedOptionProp={"catalog_id"}
                        name={"catalog_id"}
                        isRequired={true}
                    />
                </div>

                <div className={"mt-3"}>
                    <OwButton
                        title={"create"}
                        fn={this.create}
                        active={this.state.createActive}
                        disableOnActive={true}
                        disabled={!this.state.catalog_id || !this.state.description.length}
                    />
                </div>
            </div>
        );
    }
}

export default TakeOffDetailSidebar;
